import { useNavigate } from 'react-router-dom';
import { SAUDE_BENEFICIARIOS_IMG } from '../data';

const PROGRAMA = [
  { acao: 'Participação em campanha', pontos: '+500' },
  { acao: 'Adesão a programa', pontos: '+1.000' },
  { acao: 'Atingimento de meta', pontos: '+2.000' },
  { acao: 'Renovação', pontos: '+5.000' },
];

const PILARES = [
  { titulo: 'Incentivo', frase: 'Venda mais.', icon: 'ri-flashlight-line' },
  { titulo: 'Reconhecimento', frase: 'Você atingiu sua meta.', icon: 'ri-medal-line' },
  { titulo: 'Fidelização', frase: 'Continue conosco.', icon: 'ri-heart-3-line' },
  { titulo: 'Engajamento', frase: 'Participe da campanha.', icon: 'ri-fire-line' },
  { titulo: 'Relacionamento', frase: 'Construa uma relação de longo prazo.', icon: 'ri-user-heart-line' },
];

const ROADMAP = [
  'Motor de regras de campanhas',
  'Portal de campanhas',
  'Dashboard/BI de incentivo',
  'Ranking e gamificação',
  'API de integração com operadoras',
  'Discriminação de crédito 2.0',
  'Gestão de metas',
  'ROI das campanhas',
  'Campanhas para corretores e parceiros',
  'Campanhas de relacionamento e engajamento',
];

const PUBLICOS = [
  'Operadoras',
  'Administradoras',
  'Corretoras',
  'Parceiros',
  'Equipes Comerciais',
  'Empresas',
];

export default function BeneficiariosReconhecimento() {
  const navigate = useNavigate();

  return (
    <section id="beneficiarios" className="scroll-mt-28 bg-background-100 py-20 md:py-28">
      <div className="mx-auto w-full max-w-[1240px] px-6">
        <div className="grid items-center gap-12 lg:grid-cols-2">
          <div className="order-2 lg:order-1">
            <div className="overflow-hidden rounded-3xl border border-background-200">
              <img
                src={SAUDE_BENEFICIARIOS_IMG}
                alt="Beneficiários engajados em programa de relacionamento"
                className="h-full w-full object-cover object-top"
              />
            </div>
          </div>

          <div className="order-1 lg:order-2">
            <span className="inline-flex items-center gap-2 rounded-full bg-accent-100 px-4 py-1.5 text-[11px] font-semibold uppercase tracking-[0.18em] text-accent-700">
              <i className="ri-heart-pulse-line"></i>
              Segunda linha de produto
            </span>
            <h2 className="mt-5 font-heading text-3xl font-bold leading-[1.1] tracking-[-0.02em] text-foreground-950 md:text-5xl">
              Relacionamento com <span className="text-accent-600">beneficiários e empresas</span>
            </h2>
            <p className="mt-6 max-w-xl text-base leading-relaxed text-foreground-600">
              Campanhas de engajamento para beneficiários e empresas contratantes, com a jornada:
              beneficiário → engajamento → pontos → benefício. Cada campanha desenhada em conformidade com as regras
              regulatórias e contratuais aplicáveis.
            </p>

            <div className="mt-8 rounded-3xl border border-background-200 bg-background-50 p-6">
              <p className="text-sm font-semibold text-foreground-900">Programa Empresa Saudável</p>
              <div className="mt-4 space-y-2">
                {PROGRAMA.map((item) => (
                  <div key={item.acao} className="flex items-center justify-between rounded-xl bg-background-100 px-4 py-3">
                    <span className="text-sm font-medium text-foreground-800">{item.acao}</span>
                    <span className="whitespace-nowrap rounded-full bg-accent-500 px-3 py-1 text-xs font-bold text-white">
                      {item.pontos}
                    </span>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>

        <div className="mt-20">
          <div className="mx-auto mb-12 max-w-3xl text-center">
            <span className="inline-flex items-center rounded-full border border-primary-200 bg-primary-50 px-4 py-1.5 text-[11px] font-semibold uppercase tracking-[0.22em] text-primary-700">
              Reconhecimento
            </span>
            <h2 className="mt-5 font-heading text-3xl font-bold leading-[1.1] tracking-[-0.02em] text-foreground-950 md:text-5xl">
              Incentivo, reconhecimento e fidelização — <span className="text-primary-600">não só pontos</span>
            </h2>
            <p className="mt-5 text-base leading-relaxed text-foreground-600">
              Mudamos o discurso de &quot;plataforma de pontos&quot; para &quot;plataforma de incentivo, reconhecimento e fidelização&quot;.
            </p>
          </div>

          <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-5">
            {PILARES.map((pilar) => (
              <article key={pilar.titulo} className="flex flex-col rounded-3xl border border-background-200 bg-background-50 p-6 text-center">
                <span className="mx-auto flex h-12 w-12 items-center justify-center rounded-full bg-primary-100 text-primary-700">
                  <i className={`${pilar.icon} text-xl`}></i>
                </span>
                <h3 className="mt-4 font-heading text-base font-bold text-foreground-950">{pilar.titulo}</h3>
                <p className="mt-2 text-sm leading-snug text-foreground-600">&quot;{pilar.frase}&quot;</p>
              </article>
            ))}
          </div>
        </div>

        <div className="mt-20 rounded-3xl bg-foreground-900 p-8 md:p-12">
          <div className="grid gap-10 lg:grid-cols-2">
            <div>
              <h3 className="font-heading text-2xl font-bold text-background-50 md:text-3xl">Roadmap prioritário para Saúde</h3>
              <div className="mt-6 flex flex-wrap gap-2">
                {ROADMAP.map((item, index) => (
                  <span key={item} className="inline-flex items-center gap-2 rounded-full border border-white/10 bg-white/5 px-3.5 py-1.5 text-xs font-medium text-background-100">
                    <span className="font-heading text-[10px] font-bold text-accent-300">{String(index + 1).padStart(2, '0')}</span>
                    {item}
                  </span>
                ))}
              </div>
            </div>
            <div>
              <h3 className="font-heading text-2xl font-bold text-background-50 md:text-3xl">Uma plataforma. Múltiplas jornadas.</h3>
              <p className="mt-4 text-sm leading-relaxed text-background-200">
                Da operadora à equipe comercial, a GetPoints conecta todos os participantes do ecossistema de saúde em
                campanhas de incentivo mensuráveis, automatizadas e rastreáveis.
              </p>
              <div className="mt-6 flex flex-wrap gap-2">
                {PUBLICOS.map((publico) => (
                  <span key={publico} className="rounded-full bg-primary-500 px-3.5 py-1.5 text-xs font-semibold text-white">
                    {publico}
                  </span>
                ))}
              </div>
              <button
                type="button"
                onClick={() => navigate('/solicitar-demo')}
                className="mt-8 inline-flex h-12 cursor-pointer items-center justify-center gap-2 whitespace-nowrap rounded-full bg-accent-500 px-7 text-sm font-semibold text-white transition-colors hover:bg-accent-600"
              >
                Fale com um especialista em saúde
                <i className="ri-arrow-right-line text-lg"></i>
              </button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}